import React, { useState } from 'react';
import ProductDetail from './ProductDetail';
import './CategoryProductGrid.css';

function CategoryProductGrid({ products, onAddToCart }) {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedProduct, setSelectedProduct] = useState(null);

  // Group products by category
  const categories = [
    'Accessories',
    'Bags', 
    'Flags',
    'Hats',
    'Hoodies',
    'Jackets',
    'Mugs',
    'Skully',
    'Sleeves',
    'Sweat Suits',
    'Totes',
    'Towels',
    'T-Shirts'
  ];

  const getProductsByCategory = (category) => {
    return products.filter(p => p.category === category);
  };

  const scrollToCategory = (category) => {
    const element = document.getElementById(`category-${category.toLowerCase().replace(/\s+/g, '-')}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleAddToCart = (product) => {
    if (onAddToCart) {
      onAddToCart(product);
    }
  };

  return (
    <div className="category-product-grid">
      {/* Compact Category Filter */}
      <div className="category-filter">
        <div className="category-filter-list">
          {categories.map(category => {
            const categoryProducts = getProductsByCategory(category);
            if (categoryProducts.length > 0) {
              return (
                <button
                  key={category}
                  className={`category-filter-btn ${selectedCategory === category ? 'active' : ''}`}
                  onClick={() => {
                    setSelectedCategory(category);
                    scrollToCategory(category);
                  }}
                >
                  {category}
                  <span className="category-count">({categoryProducts.length})</span>
                </button>
              );
            }
            return null;
          })}
        </div>
      </div>

      {/* Product Categories */}
      <div className="product-categories">
        {categories.map(category => {
          const categoryProducts = getProductsByCategory(category);
          
          // Skip categories with no products
          if (categoryProducts.length === 0) {
            return null;
          }

          return (
            <div 
              key={category} 
              id={`category-${category.toLowerCase().replace(/\s+/g, '-')}`}
              className="product-category-section"
            >
              <div className="category-header">
                <h2 className="category-title">{category}</h2>
                <span className="category-product-count">{categoryProducts.length} items</span>
              </div>
              
              <div className="horizontal-product-grid">
                {categoryProducts.map(product => (
                  <div key={product.id} className="horizontal-product-card">
                    <div className="compact-product-card" onClick={() => setSelectedProduct(product)}>
                      <div className="compact-product-image-container">
                        <img 
                          src={product.imageUrl || '/placeholder-image.jpg'} 
                          className="compact-product-image"
                        />
                        
                        {/* Category Badge Overlay */}
                        <div className="compact-category-overlay">
                          {product.category}
                        </div>
                      </div>
                      
                      <div className="compact-product-info">
                        <div className="compact-product-main">
                          <h3 className="compact-product-name">{product.name}</h3>
                          <div className="compact-product-price">${product.price}</div>
                        </div>
                        <div className="compact-product-meta">
                          <span className="compact-product-category">{product.category}</span>
                          {product.color && <span className="compact-product-color">• {product.color}</span>}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
      
      {/* Product Detail Modal */}
      {selectedProduct && (
        <ProductDetail
          product={selectedProduct}
          onClose={() => setSelectedProduct(null)}
          onAddToCart={onAddToCart}
        />
      )}
    </div>
  );
}

export default CategoryProductGrid;
